/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";
import "./ClustersVisualRepresentation.scss";
import Avatar from "../../../components/Avatar/Avatar";
import { Cluster } from "../utils";
import classNames from "classnames";

import { VisuallyHidden } from "@evidenceb/athena-common/ui/VisuallyHidden";
import { defineMessages, useIntl } from "react-intl";
import { commonMessages } from "../../../utils/messages";

type Props = {
    clustersInfo: Cluster[];
    selectedCluster?: string;
    onClusterSelection?: (clusterId: string) => void;
    studentId?: string;
    className?: string;
};

const ClustersVisualRepresentation = ({
    clustersInfo,
    selectedCluster,
    onClusterSelection,
    studentId,
    className,
}: Props) => {
    const intl = useIntl();
    return (
        <div
            className={classNames("clusters-visual", className, {
                "--student-visual": studentId,
            })}
        >
            {clustersInfo.map((cluster) => {
                return (
                    <div
                        key={`clusters-visual__item-${cluster.id}`}
                        className="clusters-visual__item"
                    >
                        {onClusterSelection && (
                            <button
                                onClick={() => {
                                    onClusterSelection(cluster.id);
                                }}
                            >
                                <VisuallyHidden as="span">
                                    {`${intl.formatMessage(
                                        commonMessages.select
                                    )} ${intl.formatMessage(messages.group)} ${
                                        cluster.membersInfo[0].name
                                    }`}
                                </VisuallyHidden>
                            </button>
                        )}
                        <div
                            className={classNames(
                                "clusters-visual__group-name",
                                {
                                    "--selected":
                                        selectedCluster === cluster.id,
                                }
                            )}
                        >
                            {cluster.membersInfo[0].name}
                        </div>
                        <div
                            key={"circle-" + cluster.id}
                            className={classNames("clusters-visual__circle", {
                                "--selected": selectedCluster === cluster.id,
                            })}
                        >
                            {cluster.membersInfo
                                .filter((member) => member.type === "student")
                                .map((member) => (
                                    <Avatar
                                        className={
                                            member.id === studentId
                                                ? "clusters-visual__current-student"
                                                : ""
                                        }
                                        key={member.id}
                                        name={member.name}
                                    />
                                ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ClustersVisualRepresentation;

const messages = defineMessages({
    group: { id: "dashboard-common-group", defaultMessage: "Group" },
});
